export const UT_LIST = "UT_LIST";
export const CREATE_FD_RESULT = "CREATE_FD_RESULT";
export const GET_VIEW_FD = "GET_VIEW_FD";
export const GET_CLAIM_DATA = "GET_CLAIM_DATA";
export const BACK_TO_MODIFICATION = "BACK_TO_MODIFICATION";
export const VERIFY_INVOICE_NUMBERS = "VERIFY_INVOICE_NUMBERS";
export const EDIT_CLIENT_DETAILS = "EDIT_CLIENT_DETAILS";
